<template>
    <div id="step3">
        <a-result v-if="this.nonMerOrder.nonMerOrderDetails == null || this.nonMerOrder.nonMerOrderDetails == 0"
            status="warning" title="Please select item(s) first."></a-result>
        <a-row v-else>
            <p style="font-size: 13px;font-weight: 800;" class="sbxs mt4">
                <a-icon type="caret-down" />Delivery Address</p>
            <a-row class="step5_Order">
                <a-form :form="form">
                    <a-row>

                        <a-col :span="12">
                            <a-form-item label="Consignee" v-bind="formItemLayout">
                                <a-input-search size="small" autocomplete="off"
                                    :placeholder="$t('publicLang.PleaseEnter')" style="width: 100%"
                                    @search="consigneeSearch" v-decorator="['consignee',
                                    {
                                        initialValue: onsigneecValue.consignee,
                                        rules: [{ required: true, message: $t('publicLang.Required')
                                    }]}
                             ]" />
                            </a-form-item>
                        </a-col>

                        <a-col :span="12">
                            <a-form-item label="Contact" v-bind="formItemLayout">
                                <a-input autocomplete="off" size="small" :placeholder="$t('publicLang.PleaseEnter')"
                                    v-decorator="['contact',{ initialValue: onsigneecValue.contact}]" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="Phone" v-bind="formItemLayout">
                                <a-input size="small" autocomplete="off" :placeholder="$t('publicLang.PleaseEnter')"
                                    v-decorator="['phone',
                                 { initialValue: onsigneecValue.tel1,rules: [{ required: false                                                                  
                                  }]}]" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="Email" v-bind="formItemLayout">
                                <a-input size="small" autocomplete="off" :placeholder="$t('publicLang.PleaseEnter')"
                                    v-decorator="['email',{ initialValue: onsigneecValue.email}]" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="Address 1" v-bind="formItemLayout">
                                <a-input size="small" autocomplete="off" :placeholder="$t('publicLang.PleaseEnter')"
                                    v-decorator="['address1',{ initialValue: onsigneecValue.address1,
                                                                    rules: [
                                                                      {
                                                                        validator: checkInputEn,
                                                                      },
                                                                    ],
                                        }]" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="Address 2" v-bind="formItemLayout">
                                <a-input size="small" autocomplete="off" :placeholder="$t('publicLang.PleaseEnter')"
                                    v-decorator="['address2',{initialValue: onsigneecValue.address2,
                                                                    rules: [
                                                                      {
                                                                        // validator: checkInputEn,
                                                                      },
                                                                    ],
                                         }]" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="中文地址" v-bind="formItemLayout">
                                <a-input size="small" autocomplete="off" :placeholder="$t('publicLang.PleaseEnter')"
                                    v-decorator="['address3',{initialValue: onsigneecValue.address3,
                                    rules: [
                                          {
                                            //validator: checkInputCn,
                                          },
                                    ]
                                }]" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="District" v-bind="formItemLayout">
                                <a-select style="width: 100%;" allowClear size="small"
                                    :placeholder="$t('publicLang.PleaseSelect')"
                                    v-decorator="['address4',{initialValue: onsigneecValue.address4}]">
                                    <a-select-option v-for="item in stepSelectData.tmsDistrict" :value="item.code">
                                        {{item.codeDesc}}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="City" v-bind="formItemLayout">
                                <a-input size="small" autocomplete="off" :placeholder="$t('publicLang.PleaseEnter')"
                                    v-decorator="['city',{initialValue: onsigneecValue.city}]" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="State" v-bind="formItemLayout">
                                <a-input size="small" autocomplete="off" :placeholder="$t('publicLang.PleaseEnter')"
                                    v-decorator="['state',{initialValue: onsigneecValue.state}]" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="Country" v-bind="formItemLayout">
                                <a-input size="small" autocomplete="off" :placeholder="$t('publicLang.PleaseEnter')"
                                    v-decorator="['country',{initialValue: onsigneecValue.country}]" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="Zip" v-bind="formItemLayout">
                                <a-input size="small" autocomplete="off" :placeholder="$t('publicLang.PleaseEnter')"
                                    v-decorator="['zip',{initialValue: onsigneecValue.zip}]" />
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
            </a-row>
        </a-row>


        <div style="height: 45px;"></div>

        <div :style="{
              position: 'absolute',
              right: 0,
              bottom: 0,
              width: '100%',
              borderTop: '1px solid #e9e9e9',
              padding: '10px 16px',
              background: '#fff',
              zIndex: 1,}">
            <a-button @click='goTypeClick("Back")' class="fl" type="primary" size="small"><img
                    src="../../../../assets/img/Liqutor-left.png" width="13" height="12" class="mr4">Previous</a-button>
            <a-button
                :disabled="this.nonMerOrder.nonMerOrderDetails== null || this.nonMerOrder.nonMerOrderDetails.length == 0"
                @click='goTypeClick("Next")' class="fr" type="primary" size="small"><img
                    src="../../../../assets/img/Liqutor-arrow-right.png" width="13" height="12" class="mr4">Next
            </a-button>
            <div style="text-align: center">
                <a-button
                    :disabled="this.nonMerOrder.nonMerOrderDetails == null || this.nonMerOrder.nonMerOrderDetails.length == 0"
                    @click="savenonMerStep3" type="primary" size="small"><img
                        src="../../../../assets/img/Liqutor-save.png" width="13" height="12" class="mr4">Save and Exit
                </a-button>

                <a-popconfirm title="Are you sure reset?" ok-text="Yes" cancel-text="No" @confirm="resetStep3">
                    <a-button
                        :disabled="this.nonMerOrder.nonMerOrderDetails == null || this.nonMerOrder.nonMerOrderDetails.length == 0"
                        style='margin-left: 40px;' type="danger" size="small"><img
                            src="../../../../assets/img/Liqutor-refresh.png" width="13" height="12" class="mr4">Reset
                    </a-button>
                </a-popconfirm>


            </div>
        </div>
        <!--搜索-->
        <a-modal title="Consignee" :visible="consigneeVis" width="80%" :footer="null"
            @cancel="() => (consigneeVis = !consigneeVis)">
            <a-row style="height: 450px;">
                <vxe-table stripe highlight-hover-row border resizable show-overflow :data.sync="onsigneecTable"
                    size="mini" height="auto" @cell-click="cellClickEvent">
                    <template v-slot:empty>
                        <span style="font-size: 12px; color: red;"> {{ $t('pubGicSet.NoRecordfound') }} </span>
                    </template>
                    <vxe-table-column field="consignee" title="Consignee" show-header-overflow="ellipsis"
                        show-overflow="ellipsis"></vxe-table-column>
                    <vxe-table-column field="contact" title="Contact" show-header-overflow="ellipsis"
                        show-overflow="ellipsis"></vxe-table-column>
                    <vxe-table-column field="tel1" title="Phone" show-header-overflow="ellipsis"
                        show-overflow="ellipsis"></vxe-table-column>
                    <vxe-table-column field="postalCode" title="Email" show-header-overflow="ellipsis"
                        show-overflow="ellipsis"></vxe-table-column>
                    <vxe-table-column field="address1" title="Address1" show-header-overflow="ellipsis"
                        show-overflow="ellipsis"></vxe-table-column>
                    <vxe-table-column field="address2" title="Address2" show-header-overflow="ellipsis"
                        show-overflow="ellipsis"></vxe-table-column>
                    <vxe-table-column field="address3" title="Address3" show-header-overflow="ellipsis"
                        show-overflow="ellipsis"></vxe-table-column>
                    <vxe-table-column field="address4" title="Address4" show-header-overflow="ellipsis"
                        show-overflow="ellipsis"></vxe-table-column>
                    <vxe-table-column field="city" title="City" show-header-overflow="ellipsis"
                        show-overflow="ellipsis"></vxe-table-column>
                    <vxe-table-column field="state" title="State" show-header-overflow="ellipsis"
                        show-overflow="ellipsis"></vxe-table-column>
                    <vxe-table-column field="country" title="Country" show-header-overflow="ellipsis"
                        show-overflow="ellipsis"></vxe-table-column>
                    <vxe-table-column field="zip" title="Zip" show-header-overflow="ellipsis" show-overflow="ellipsis">
                    </vxe-table-column>
                </vxe-table>
            </a-row>
        </a-modal>
    </div>
</template>
<script>
    import { mapState } from "vuex"
    import ajax from '../../../../api/ajax'
    import api from '../../../../api/url'
    import moment from "moment";
    export default {
        props: {
            nonMerOrder: { // 父组件传进来的 所有这单临时数据
                type: Object,
                default: function () {
                    return {};
                }
            },





            initCloseValue: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            stepSelectData: {
                type: Object,
                default: function () {
                    return {};
                }
            },
        },
        data() {
            return {
                form: this.$form.createForm(this),
                onsigneecTable: [],
                onsigneecValue: {},
                consigneeVis: false,
                formItemLayout: {
                    labelCol: {
                        xs: {
                            span: 24
                        },
                        sm: {
                            span: 6
                        }
                    },
                    wrapperCol: {
                        xs: {
                            span: 24
                        },
                        sm: {
                            span: 16
                        }
                    }
                },
                address1Check: false,
                // sysPhoneLength: JSON.parse(localStorage.getItem('systemParam')).so_inv_phone_max == null ||
                //     JSON.parse(localStorage.getItem('systemParam')).so_inv_phone_max.size == 0 ? 20 : JSON.parse(
                //         localStorage.getItem('systemParam')).so_inv_phone_max, //系统参数:Phone最大输入长度
                test: false
            }
        },
       computed: {
             ...mapState(["systemParam"]),
        },

        created() {
            this.clearFromInitValue()
            this.onsigneecValue = {
                zip: this.nonMerOrder.zip,
                country: this.nonMerOrder.country,
                state: this.nonMerOrder.state,
                city: this.nonMerOrder.city,
                address1: this.nonMerOrder.address1,
                address2: this.nonMerOrder.address2,
                address3: this.nonMerOrder.address3,
                address4: this.nonMerOrder.address4,
                email: this.nonMerOrder.email,
                tel1: this.nonMerOrder.tel,
                contact: this.nonMerOrder.contact,
                consignee: this.nonMerOrder.consignee,
            }
            console.info(this.onsigneecValue)
        },
        methods: {
            moment,
            //            consigneeSearch
            consigneeSearch() {
                this.consigneeVis = true
                let params = {
                    "btperpkg": this.form.getFieldValue('btperpkg'),
                    "consignee": this.form.getFieldValue('consignee'),
                    "itemRemark": this.form.getFieldValue('itemRemark'),
                    "itemSize": this.form.getFieldValue('itemSize'),
                    "region": this.form.getFieldValue('region'),
                    "sku": this.form.getFieldValue('sku'),
                    "wineName": this.form.getFieldValue('wineName'),
                    "year": this.form.getFieldValue('year')
                }
                for (let i in params) {
                    if (params[i] == '') {
                        delete params[i]
                    }
                }
                ajax.post(api.INVWINECONSIGNEE, params).then(res => {
                    this.onsigneecTable = res.data
                })
            },

            goTypeClick(type) {
                if ("Back" == type) { // 返回上一层
                    this.$emit('goType', type)
                    return;
                } else {
                    this.saveAndRedirect(type) // 保存及跳转
                }
            },
            savenonMerStep3() {
                this.saveAndRedirect('close') // 保存及关闭
            },
            saveAndRedirect(redirectType) {
                console.info(this.nonMerOrder.nonMerOrderDetails)
                if (this.nonMerOrder.nonMerOrderDetails == null || this.nonMerOrder.nonMerOrderDetails.length == 0) {
                    if (redirectType == 'close') {
                        this.$emit('goClose', redirectType)
                    } else {
                        this.$emit('goType', redirectType)
                    }
                } else {
                    this.form.validateFields((err, values) => {
                        if (!err) {
                            this.nonMerOrder.address1 = values.address1,
                                this.nonMerOrder.address2 = values.address2,
                                this.nonMerOrder.address3 = values.address3,
                                this.nonMerOrder.address4 = values.address4,
                                this.nonMerOrder.tel = values.phone,
                                this.nonMerOrder.city = values.city,
                                this.nonMerOrder.consignee = values.consignee,
                                this.nonMerOrder.contact = values.contact,
                                this.nonMerOrder.country = values.country,
                                this.nonMerOrder.currentStep = '3',
                                this.nonMerOrder.email = values.email,
                                this.nonMerOrder.state = values.state,
                                this.nonMerOrder.zip = values.zip
                            ajax.post(api.INVWINEADDTEMPORDERNONMER, this.nonMerOrder).then(res => {
                                if (res.code == 200) {
                                    if (redirectType == 'close') {
                                         this.$message.success(res.msg);
                                        this.$emit('goClose', redirectType)
                                    } else {
                                        this.$emit('goType', redirectType)
                                    }
                                } else {
                                    this.$message.warning(res.msg);
                                }
                            })

                        }
                    })
                }
            },
            //            清除
            resetStep3() {
                     this.nonMerOrder.address1 = '',
                     this.nonMerOrder.address2 = '',
                     this.nonMerOrder.address3 = '',
                     this.nonMerOrder.address4 = '',
                     this.nonMerOrder.tel = '',
                     this.nonMerOrder.city = '',
                     this.nonMerOrder.consignee = '',
                     this.nonMerOrder.contact = '',
                     this.nonMerOrder.country = '',
                     this.nonMerOrder.currentStep = '3',
                     this.nonMerOrder.email ='',
                     this.nonMerOrder.state = '',
                     this.nonMerOrder.zip = ''
                ajax.post(api.INVWINEADDTEMPORDERNONMER, this.nonMerOrder).then(res => {
                    if (res.code == 200) {
                        this.form.resetFields();
                        this.onsigneecValue = {}
                    } else {
                        this.$message.warning(res.msg);
                    }
                })
            },


            //            consignee选中当前value
            cellClickEvent({
                row
            }) {
                this.onsigneecValue = row
                this.form.setFieldsValue({
                    'consignee': this.onsigneecValue.consignee,
                    'phone': this.onsigneecValue.tel1,
                    'address1': this.onsigneecValue.address1,
                })
                this.consigneeVis = false
            },
            clearFromInitValue() {
                this.onsigneecValue = {}
                this.form.resetFields()
            },
            checkInputEn(rule, value, callback) { //校验不能输入中文
                let pattern = new RegExp(/^[^\u4e00-\u9fa5]{0,}$/)
                if (!pattern.test(value)) {
                    callback(this.$t('wine.inputEnglish'));
                } else {
                    callback();
                }
            },
            checkInputCn(rule, value, callback) { //校验不能输入英文
                let addr1 = this.form.getFieldValue('address1')
                // let addr2 = this.form.getFieldValue('address2')
                // let pattern = new RegExp(/^[^a-zA-Z]{0,}$/)
                // if((addr1 == null || addr1.length == 0) && (addr2 == null || addr2.length == 0) && (value == null || value.length == 0)){
                if ((addr1 == null || addr1.length == 0) && (value == null || value.length == 0)) {
                    callback(this.$t('wine.mustInputChinese'));
                }
                // else if(!pattern.test(value)){
                //     callback(this.$t('wine.inputChinese'));
                // }
                else {
                    callback();
                }
            },
            checkPhone(rule, value, callback) { //校验长度
                let so_inv_phone_max = this.systemParam.so_inv_phone_max;
                let sysPhoneLength = so_inv_phone_max == undefined || so_inv_phone_max == null || so_inv_phone_max == 0  ? 20 : so_inv_phone_max;
                if (value == null || value.length == 0) {
                    callback(this.$t('publicLang.Required'));
                } else if (value.length > sysPhoneLength) {
                    callback(this.$t('wine.maxCharacters', {
                        "0": sysPhoneLength
                    }));
                } else {
                    callback();
                }
            },
        }
    }
</script>
<style lang="less" scoped>
    #step3 {
        padding: 6px 15px 0 15px;

        .step5_Order {
            border: 1px solid #929292;
            background: #fafafa;
            padding: 8px;
        }
    }
</style>